import * as Types from '../../../../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { ExamDetailsFragmentDoc } from './load-exam.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type LockExamMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type LockExamMutation = { __typename?: 'Mutation', lockExam?: { __typename?: 'LockExamPayload', successful: boolean, exam?: { __typename?: 'Exam', id: string, name: string, date: string, duration?: number | null, medium?: string | null, typ?: string | null, has_scrambling_b?: boolean | null, number_of_additional_scramblings?: number | null, locked_at_date?: string | null, de: boolean, en: boolean, fr: boolean, it: boolean, show_first_dimension_presort?: boolean | null, allow_question_comments?: boolean | null, first_presort_criterion?: boolean | null, second_presort_criterion?: boolean | null, third_presort_criterion?: boolean | null, locked: boolean, self_assessed: boolean, is_in_the_future: boolean, provisioned: boolean, examinator_unlock_token?: string | null, content: { __typename?: 'TranslatedContent', de?: string | null, en?: string | null, fr?: string | null, it?: string | null }, presort_criteria: Array<{ __typename?: 'PresortCriteria', type?: string | null, name?: string | null, position?: number | null }> } | null, validations?: { __typename?: 'ValidationsExamGeneral', general?: Array<{ __typename?: 'ValidationsMessage', message: string }> | null } | null } | null };

export const LockExamDocument = gql`
    mutation LockExam($id: ID!) {
  lockExam(id: $id) {
    exam {
      ...ExamDetails
    }
    successful
    validations {
      general {
        message
      }
    }
  }
}
    ${ExamDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LockExamGQL extends Apollo.Mutation<LockExamMutation, LockExamMutationVariables> {
    document = LockExamDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }